/* istanbul ignore file */
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useFormContext } from 'framework/form';
import LeadsBreadcrumbs from 'domain/sales/lead/shared/LeadsBreadcrumbs';
import { SingleBreadcrumbItem, UpdateBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useLeadUrl } from 'domain/shared/lead';

/**
 * Returns lead create pages breadcrumbs.
 * @returns {*}
 * @constructor
 */
const Breadcrumbs = () => {
  const { id } = useParams<{ id: string }>();
  const { data = {} } = useFormContext();
  const { firstName, middleName, lastName } = data;
  const { getSingleEntityUrl } = useLeadUrl();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const displayedName = useMemo(() => `${firstName} ${middleName || ''} ${lastName}`, []);

  return (
    <LeadsBreadcrumbs>
      <SingleBreadcrumbItem entity={displayedName} link={getSingleEntityUrl(id)} />
      <UpdateBreadcrumbItem />
    </LeadsBreadcrumbs>
  );
};

export default Breadcrumbs;
